// import React from "react";
import TERMS_OF_USE from "../../docs/terms-of-use.pdf";
import React, { useState } from "react";
import _ from "lodash";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const PDF_OPTIONS = {
  isEvalSupported: false,
};

const LegalDocument = ({ pageWidth = 800 }) => {
  const [pageCount, setPageCount] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setPageCount(numPages);
  };
  const renderPages = () => {
    return _.times(pageCount, (index) => {
      return (
        <Page
          key={index}
          pageIndex={index}
          width={pageWidth}
          loading=""
          error={
            <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
          }
          noData={
            <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
          }
        />
      );
    });
  };

  return (
    <div className="legal-document">
      <div className="document-container">
        <div
          className="document"
          style={{ width: "100%", maxWidth: `${pageWidth + 12}px` }}
        >
          <Document
            file={TERMS_OF_USE}
            options={PDF_OPTIONS}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<se-loading loading="true" />}
            error={
              <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
            }
            noData={
              <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
            }
            renderMode="svg"
          >
            {renderPages()}
          </Document>
        </div>
      </div>
    </div>
  );
};

export default LegalDocument;
